import React from 'react';
import loadable from '@loadable/component';
import pMinDelay from 'p-min-delay';
import Loading from './Loading';
import { LoadableErrorBoundary, TimeoutError } from './ErrorBoundry';

const FuseLoadable = (opts) => {
    const { loader, delayMs = 300, timeoutMs = 10000, ...loadableOpts } = opts;

    const withTimeout = (promise, ms) =>
        ms <= 0
            ? promise
            : new Promise((resolve, reject) => {
                  const timer = setTimeout(() => {
                      console.log('Timout');
                      reject(new TimeoutError(`Loadable timed out after ${ms} ms`));
                  }, ms);

                  promise.then(
                      (value) => {
                          clearTimeout(timer);
                          resolve(value);
                      },
                      (err) => {
                          clearTimeout(timer);
                          reject(err);
                      }
                  );
              });

    const LoadableComponent = loadable(
        () => {
            let promise = loader();

            if (delayMs > 0) {
                promise = pMinDelay(promise, delayMs);
            }

            promise = withTimeout(promise, timeoutMs);

            return promise;
        },
        {
            fallback: <Loading />,
            ...loadableOpts,
        }
    );

    const Wrapped = React.forwardRef((props, ref) => (
        <LoadableErrorBoundary>
            <LoadableComponent {...props} ref={ref} />
        </LoadableErrorBoundary>
    ));

    Wrapped.displayName = 'FuseLoadable';

    return Wrapped;
};

export default FuseLoadable;
